import React, { useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { Avatar, Typography, Box, Card, CardContent } from '@mui/material';
import { styled } from '@mui/system';
import { Container } from '@mui/material';
import ProductList from './ProductList';
import {Helmet} from "react-helmet";

const StyledTypography = styled(Typography)({
    textAlign: 'center',
    fontSize: '1.2rem',
    fontWeight: '600',
    marginTop: '1rem',
});

const StyledTypographyBio = styled(Typography)({
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: '400',
    marginTop: '0.5rem',
    marginBottom: '1rem',
});

const StyledCard = styled(Card)({
    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
    borderRadius: '15px',
    padding: '2rem',
    marginTop: '0rem',
    backgroundColor: '#f2f2f2',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    marginBottom: '2rem'
});

const MyProducts = () => {
    const { user, isAuthenticated } = useAuth0();
    const [petOwnerProfile, setPetOwnerProfile] = useState({
        name: '',
        bio: '',
        fileUrl: '',
    });

    useEffect(() => {
        const fetchPetOwnerProfile = async () => {
            if (isAuthenticated && user) {
                try {
                    const response = await fetch('/.netlify/functions/getProductOwnerProfile', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ userEmail: user.email }),
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error ${response.status}`);
                    }

                    const petOwnerProfileData = await response.json();

                    setPetOwnerProfile(petOwnerProfileData);
                } catch (error) {
                    console.error('Error fetching pet owner profile:', error);
                }
            }
        };

        fetchPetOwnerProfile();
    }, [user, isAuthenticated]);

    return (
        <Container maxWidth="md">

            <Helmet>
                <title>Wagzters - My Products</title>
                <meta name="description" content="View and manage your list of pets on Wagzters, the dedicated cloud repository for pet lovers. Connect and share the love for your furry friends."/>
                <meta property="og:title" content="Wagzters - My Pets" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://i.imgur.com/jrbqoWp.png" />
                <meta property="og:url" content="https://wagzters.com/myproducts" />
                <meta property="og:description" content="View and manage your list of pets on Wagzters, the dedicated cloud repository for pet lovers. Connect and share the love for your furry friends." />
            </Helmet>


            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    mt: 0
                }}>
                {isAuthenticated && user && (
                    <StyledCard>
                        <Avatar
                            alt={petOwnerProfile.name || ''}
                            src={petOwnerProfile.fileUrl || user.picture}
                            sx={{ width: 80, height: 80, marginTop: '1rem' }}
                        />
                        <CardContent>
                            <StyledTypography
                                variant="h5"
                                sx={{
                                    color:'#16cc7d'
                                }}
                            >
                                {petOwnerProfile.name || ''}
                            </StyledTypography>
                            <StyledTypographyBio
                                variant="body2"
                                color="#9ca3af"
                            >
                                {petOwnerProfile.bio}
                            </StyledTypographyBio>
                        </CardContent>
                    </StyledCard>
                )}
                <Typography variant="h6" component="div"
                            style={{
                                marginBottom: '1em',
                                color:'#333333'
                            }}>
                    My Products
                </Typography>
                <ProductList />
            </Box>
        </Container>
    );
};

export default MyProducts;
